/* eslint-disable no-console */
import {Flex, Space} from 'antd';
import React, {Fragment} from 'react';

import {TF} from '../../../constants/Common';
import PilComp from '../../DisplayComponent/PilComp';
import {WasteKey} from '../../Forms/Constants/IP/WasteKeyLabel';
import {unitTypes} from '../../Forms/interface/unitChange';
import {renderFormPreview} from '../commonFunctions';
import {objTypes} from '../Constants/commonConstants';

import SupplyChainListData from './SupplyChainListData';
import TimeFrameRender from './TimeFrameRender';

const FormPreview: React.FC<{formData: any; formPreview: any[]}> = ({
  formData,
  formPreview
}) => {
  return (
    <Flex className="formPreviewFlex">
      {formPreview?.map((item, index) => {
        const value = formData[item?.key];

        const interRelatedKey = formData[item?.relatedKey];

        const renderValue = renderFormPreview(value, item, interRelatedKey);

        if (item?.checkRelatedKeyFalsy && !formData[item?.relatedKey]) {
          return null;
        }

        if (item?.skip?.(formData)) {
          return null;
        }

        if (
          (formData[item?.relatedKey] === false && item?.relatedKey) ||
          (item.relatedKey === 'country' && formData[item?.relatedKey] !== 101)
        ) {
          return null;
        }

        if (item.type === objTypes.productRelatedKey) {
          const relatedKeyValue = formData[item?.relatedKey];
          if (relatedKeyValue) {
            const matchedFormat =
              item?.format.find(
                (formatItem: any) => formatItem?.value === relatedKeyValue
              )?.state ?? unitTypes.NA;
            if (matchedFormat === unitTypes.NA) return null;
          }
        }

        const color = '#d3eec6';

        return (
          <Fragment key={index}>
            {!item.hidden && (
              <div
                key={item.key}
                className="formDataDetails"
                style={{
                  flexDirection: item.renderType === 'multi' ? 'column' : 'row'
                }}
              >
                {item.type === objTypes.timeFrameData ? (
                  item.key === TF ? (
                    <TimeFrameRender value={value} label={item?.label} />
                  ) : (
                    value?.map((mainItem: any, i: number) => {
                      const mainLabelUnit = mainItem?.timeFrameData.find(
                        (item: any) => {
                          return (
                            item.type === WasteKey.notTreated.wasteNotTreated
                          );
                        }
                      );

                      return (
                        <Fragment key={i}>
                          <div
                            className="formProperty"
                            style={{
                              fontWeight: '700',
                              padding: '1.2rem 0 0px 0px'
                            }}
                          >
                            {`${item?.mainLabel?.[i]} ${
                              mainLabelUnit ? `(${mainLabelUnit?.unit}) :` : ''
                            }`}
                          </div>
                          <TimeFrameRender
                            value={mainItem?.timeFrameData}
                            label={item?.label}
                          />
                        </Fragment>
                      );
                    })
                  )
                ) : item?.type === objTypes.supplyChainListData ? (
                  <SupplyChainListData value={value} item={item} />
                ) : (
                  <Flex vertical={Array.isArray(renderValue)}>
                    <div className="formProperty">{`${item?.label} :`}</div>
                    <Space className="formOutput" size={[8, 16]} wrap>
                      {Array.isArray(renderValue) && item.key !== TF ? (
                        renderValue.map((items, index) => {
                          return (
                            <div key={index}>
                              <PilComp
                                value={items}
                                color="#d3eec6"
                                style={{padding: '4px 10px'}}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <>
                          {item?.isGreen ? (
                            <PilComp value={renderValue} color={color} />
                          ) : (
                            <div>{renderValue}</div>
                          )}
                        </>
                      )}
                    </Space>
                  </Flex>
                )}
              </div>
            )}
          </Fragment>
        );
      })}
    </Flex>
  );
};

export default FormPreview;
